import { initializeMasks } from "./input-masks";

/**
 * Formats a digit string as MM/DD/YYYY, inserting slashes after the 2nd and 4th digits.
 * Matches jQuery mask `09/09/0000` behavior.
 * @param {string} digits - string of digits only
 * @returns {string}
 */
export function dateFormatter(digits) {
  const trimmed = digits.slice(0, 8);

  if (trimmed.length <= 2) {
    return trimmed;
  }

  if (trimmed.length <= 4) {
    return `${trimmed.slice(0, 2)}/${trimmed.slice(2)}`;
  }

  return `${trimmed.slice(0, 2)}/${trimmed.slice(2, 4)}/${trimmed.slice(4)}`;
}

export function initializeDateMasks(container) {
  return initializeMasks(container, "input.date-mask", dateFormatter, 8);
}
